import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { connect } from 'react-redux'
import { getApiURL } from '../../helpers/api'
import Contributions from './Contributions'
//import Placeholder from '../misc/placeholder'

const Section = props => {
  const {
    IsCollapsed,
    Contributor,
    editable,
    isChild,
    User,
    Confidential,
    Children,
    Title,
    ContributorSectionID,
    ContributorProfileSectionID,
    countryId,
    CreatedOn,
    LastModifiedOn,
    LastModifiedBy,
    groups,
    confidentialGroups,
    Subtitle,
  } = props;

  const _editable = typeof editable !== "undefined" ? editable : true;
  let { Markdown } = props;
  if (Markdown.trim().length <= 2) {
    Markdown = "";
  }

  const [collapsed, setIsCollapsed] = useState(IsCollapsed || false);

  //replace sharepoint images with the API version
  Markdown = Markdown.replace(
    /https:\/\/greenclimate.sharepoint.com\/sites\/ContributorProfile\/Shared%20Documents\/public\//g,
    getApiURL() + `getSharepointImage?url=`
  );

  const is_section_hidden =
    !(Children || []).length && (!Markdown || Markdown.trim().length < 2);

  //Section is confidential, person not in confidential groups, return null
  if (Confidential && !props.is_user_editor && !props.is_user_confidential) {
    return null;
  }

  //hide section if empty, except for admins
  if (!(Children || []).length && is_section_hidden && !props.is_user_editor) {
    return null;
  }

  Markdown = Markdown.split("{{status_contribution_table}}");

  // TODO: debug function
  // console.warn("admin", props.is_user_editor, "SMT", props.is_user_confidential)

  const collapsedClass = collapsed ? "collapsed" : "";

  return Title ? (
    <React.Fragment>
      <a
        className="anchor"
        href="/"
        id={`section-${ContributorProfileSectionID}`}
      >
        {" "}
      </a>
      <section
        className={`section${isChild ? " subsection" : ""}${
          Confidential ? " is-confidential" : ""
        }${
          !(Children || []).length && is_section_hidden ? " print-none" : ""
        } ${collapsedClass}`}
      >
        {!isChild ? (
          <h3 className={`section-header`}>
            {Confidential ? <i className="fas fa-lock fa-xs" /> : ""}
            <button
              onClick={() => setIsCollapsed((c) => !c)}
              type="button"
              className="btn btn-link text-secondary"
            >
              <i
                className={`fas fa-${collapsedClass ? "plus" : "minus"}-square`}
              />
            </button>{" "}
            {Title}
            {Subtitle && (
              <React.Fragment>
                <br />
                <small className="subtitle">{Subtitle}</small>
              </React.Fragment>
            )}
            {/* Is Parent Section */}{" "}
            {props.is_user_editor && is_section_hidden && (
              <React.Fragment>
                <small>
                  <span className="badge badge-warning">
                    Hidden from users (no content)
                  </span>
                </small>{" "}
              </React.Fragment>
            )}
            {props.is_user_editor && _editable ? (
              <Link
                className="btn btn-sm btn-xs btn-light print-none"
                to={`/contributor/${countryId}/section/${ContributorSectionID}/edit`}
              >
                Edit
              </Link>
            ) : null}
          </h3>
        ) : (
          <h4 className={`section-header mt-2`}>
            {Confidential ? <i className="fas fa-lock fa-xs print-none" /> : ""}
            <button
              onClick={() => setIsCollapsed((c) => !c)}
              type="button"
              className="btn btn-link text-secondary"
            >
              <i
                className={`fas fa-${collapsedClass ? "plus" : "minus"}-square`}
              />
            </button>{" "}
            {Title}{" "}
            {props.is_user_editor && is_section_hidden && (
              <React.Fragment>
                <small className="print-none">
                  <span className="badge badge-warning print-none">
                    Hidden from users (no content)
                  </span>
                </small>{" "}
              </React.Fragment>
            )}
            {props.is_user_editor && _editable ? (
              <Link
                className="btn btn-sm btn-xs btn-light print-none"
                to={`/contributor/${countryId}/section/${ContributorSectionID}/edit`}
              >
                Edit
              </Link>
            ) : null}
          </h4>
        )}

        <div className="section-content">
          <React.Fragment>
            <small className="print-none">
              Last updated{" "}
              {LastModifiedOn
                ? moment(LastModifiedOn).fromNow()
                : moment(CreatedOn).fromNow()}{" "}
              by{" "}
              <strong title={LastModifiedBy} className="color-blue">
                {User || LastModifiedBy || "-"}
              </strong>
            </small>
            <hr className="print-none" />
          </React.Fragment>

          {Children &&
            Children.map((s) => (
              <Section
                key={s.ContributorSectionID}
                {...s}
                is_user_confidential={props.is_user_confidential}
                is_user_editor={props.is_user_editor}
                confidentialGroups={confidentialGroups}
                isChild={true}
                countryId={countryId}
                groups={groups}
              />
            ))}

          {!is_section_hidden ? (
            Markdown.map((mdn, idx) => (
              <React.Fragment key={idx}>
                {idx === 1 && <Contributions Contributor={Contributor} />}
                <div className="markdown table-responsive">
                  <ReactMarkdown>{mdn}</ReactMarkdown>
                </div>
              </React.Fragment>
            ))
          ) : (
            <span className="is-empty">Empty section</span>
          )}
        </div>
      </section>
    </React.Fragment>
  ) : null;
}

const mapStateToProps = ({ okta }) => {
    return {
        groups: okta.groups,
        is_user_confidential: okta.is_user_confidential,
        is_user_editor: okta.is_user_editor
    }
}

export default connect(mapStateToProps)(Section)
